export const IronSessionOptions = {
  cookieName: 'auth.figmotion',
  password: process.env.SESSION_SECRET,
  cookieOptions: {
    secure: process.env.NODE_ENV === 'production',
  },
};
